import React from 'react';
import { Button, Modal, Group, styled, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { fieldTitles } from '../../constants';
import { FormFields } from '../../types';
import { exportToCSV } from '../../helpers';
import prepareContent from '../../helpers/prepareContent';

const ButtonGroup = styled(Group)`
    width: 100%;
`;

const FormGroup: React.FC<{
    fieldKey: string;
    title: string;
    content: string | number | File;
}> = ({ fieldKey, title, content }) => {
    return (
        <Group direction="vertical" gutter={0}>
            <Group.Item>
                <Text mb={0} size="sm" contrast="low">
                    {title}
                </Text>
            </Group.Item>
            <Group.Item>
                <Text size="lg" mb={0}>
                    {prepareContent(fieldKey, content)}
                </Text>
            </Group.Item>
        </Group>
    );
};

type ConfirmationProps = {
    setSubmitSuccessful: (successful: boolean) => void;
    submitSuccessful: boolean;
    values: FormFields;
};

const Confirmation: React.FC<ConfirmationProps> = ({
    setSubmitSuccessful,
    submitSuccessful,
    values,
}) => (
    <Modal
        isOpen={submitSuccessful}
        onClose={(): void => setSubmitSuccessful(false)}
    >
        <Modal.Header>
            <Text pr="xxl">
                <Trans>
                    If the information below is correct, press Download to
                    generate your file. Otherwise, press Modify.
                </Trans>
            </Text>
        </Modal.Header>
        <Modal.Content>
            <Group direction="vertical" gutter="lg">
                <Group.Item>
                    <Group direction="vertical" gutter="xl">
                        {(Object.keys(values) as Array<keyof FormFields>).map(
                            (fieldKey) =>
                                values[fieldKey] ? (
                                    <Group.Item
                                        key={`confirmation-${fieldKey}`}
                                    >
                                        <FormGroup
                                            fieldKey={fieldKey}
                                            title={fieldTitles[fieldKey]}
                                            content={values[fieldKey]}
                                        />
                                    </Group.Item>
                                ) : null,
                        )}
                    </Group>
                </Group.Item>
            </Group>
        </Modal.Content>
        <Modal.Footer>
            <ButtonGroup
                direction="horizontal"
                gutter="md"
                justify="space-between"
            >
                <Group.Item>
                    <Button
                        variant="ghost"
                        onClick={(): void => setSubmitSuccessful(false)}
                    >
                        Modify
                    </Button>
                </Group.Item>
                <Group.Item>
                    <Button
                        onClick={async (): Promise<void> => {
                            exportToCSV(values);
                            setSubmitSuccessful(false);
                        }}
                    >
                        <Trans>Download</Trans>
                    </Button>
                </Group.Item>
            </ButtonGroup>
        </Modal.Footer>
    </Modal>
);

export default Confirmation;
